import React from "react";
import { useMutation } from "react-query";
import { ggpsLogin } from "./gateway";
import { AxiosError } from "axios";
import { enqueueSnackbar } from "notistack";
import { t } from "i18next";

export default function useGetGgpsLogin() {
  return useMutation({
    mutationFn: ggpsLogin,
    onSuccess: (data, variables, context) => {
      window.location.href = `${data?.data?.url}`;
    },
  });
}
